/**
 * PDP gallery nav — owns current/total so Dawn SliderComponent cannot
 * overwrite them with totalPages (slides - slidesPerPage + 1), which becomes
 * count+1 on mobile when slidesPerPage floors to 0.
 *
 * Counter elements intentionally do NOT use .slider-counter--current/total,
 * so SliderComponent never binds to them.
 */
(function () {
  'use strict';

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.pdpGalleryControls === '1') return;
    gallery.dataset.pdpGalleryControls = '1';

    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!viewer) return;

    var list = viewer.querySelector('[id^="Slider-Gallery-"]');
    var nav = viewer.querySelector('.product-gallery-nav');
    var prev = viewer.querySelector('.product-gallery-nav button[name="previous"]');
    var next = viewer.querySelector('.product-gallery-nav button[name="next"]');
    var currentEl = viewer.querySelector('[data-gallery-current]');
    var totalEl = viewer.querySelector('[data-gallery-total]');
    if (!list || !currentEl || !totalEl) return;

    // Extra safety: if Dawn already bound classic counter nodes, detach them.
    if (viewer.currentPageElement) viewer.currentPageElement = null;
    if (viewer.pageTotalElement) viewer.pageTotalElement = null;

    function slides() {
      return Array.prototype.slice.call(list.children).filter(function (el) {
        return el.classList && el.classList.contains('product__media-item');
      });
    }

    function isMobileSlider() {
      var items = slides();
      var visible = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].clientWidth > 0) visible++;
      }
      return visible > 1;
    }

    function scrollIndex() {
      var items = slides();
      if (!items.length) return 0;

      var scrollLeft = list.scrollLeft;
      var best = 0;
      var bestDist = Infinity;

      for (var i = 0; i < items.length; i++) {
        var dist = Math.abs(items[i].offsetLeft - scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function activeIndex() {
      var items = slides();
      if (!items.length) return 0;

      if (isMobileSlider()) {
        return scrollIndex();
      }

      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) {
          idx = i;
          break;
        }
      }
      return idx < 0 ? 0 : idx;
    }

    function updateCounter() {
      var items = slides();
      var total = items.length;
      var idx = activeIndex();
      if (total > 0 && idx >= total) idx = total - 1;

      currentEl.textContent = String(total ? idx + 1 : 0);
      totalEl.textContent = String(total);

      var disable = total < 2;
      if (prev) {
        prev.toggleAttribute('disabled', disable);
        prev.setAttribute('aria-disabled', disable ? 'true' : 'false');
      }
      if (next) {
        next.toggleAttribute('disabled', disable);
        next.setAttribute('aria-disabled', disable ? 'true' : 'false');
      }
    }

    function go(delta) {
      var items = slides();
      if (items.length < 2) return;

      var nextIndex = (activeIndex() + delta + items.length) % items.length;
      var target = items[nextIndex];
      var mediaId = target.getAttribute('data-media-id');
      if (!mediaId) return;

      if (isMobileSlider()) {
        list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === nextIndex);
        });
        if (typeof gallery.setActiveMedia === 'function') {
          // Keep thumbnails in sync without relying on Dawn page math
          var thumb = gallery.querySelector(
            '[id^="GalleryThumbnails-"] [data-target="' + mediaId + '"]'
          );
          if (thumb && typeof gallery.setActiveThumbnail === 'function') {
            gallery.setActiveThumbnail(thumb);
          } else if (thumb) {
            gallery.querySelectorAll('[id^="GalleryThumbnails-"] button').forEach(function (btn) {
              btn.removeAttribute('aria-current');
            });
            var btn = thumb.querySelector('button');
            if (btn) btn.setAttribute('aria-current', 'true');
          }
        }
        updateCounter();
        return;
      }

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        items.forEach(function (el, i) {
          el.classList.toggle('is-active', i === nextIndex);
        });
      }
      updateCounter();
    }

    function onPrev(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(-1);
    }

    function onNext(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(1);
    }

    if (prev) prev.addEventListener('click', onPrev, true);
    if (next) next.addEventListener('click', onNext, true);

    var scrollTimer = null;
    list.addEventListener(
      'scroll',
      function () {
        if (scrollTimer) cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(updateCounter);
      },
      { passive: true }
    );

    viewer.addEventListener('slideChanged', updateCounter);

    var mo = new MutationObserver(updateCounter);
    mo.observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });

    window.addEventListener('resize', updateCounter, { passive: true });

    // Disarm Dawn counter refs after SliderComponent upgrades
    function disarmDawnCounter() {
      if (viewer.currentPageElement) viewer.currentPageElement = null;
      if (viewer.pageTotalElement) viewer.pageTotalElement = null;
      updateCounter();
    }
    disarmDawnCounter();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('slider-component').then(function () {
        // Allow constructor to finish, then detach
        requestAnimationFrame(disarmDawnCounter);
      });
    }

    updateCounter();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
